'use strict';
const angular = require('angular');

export class piperExpectedTodayWidgetComponent {

  constructor(Auth, PiperListService) {
    'ngInject';

    PiperListService.getTodayByHost({
      hostid: Auth.getCurrentUserSync()._id
    }, (data) => {
      this.data = data;
    });
  }

  $onInit() {
  }
}

export default angular.module('conduuApp.piperExpectedToday', [])
  .component('piperExpectedTodayWidget', {
    template: require('./piper-expected-today-widget.component.html'),
    bindings: {
    },
    controller: piperExpectedTodayWidgetComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/sidebar/piper-expected-today-widget/piper-expected-today-widget.component.js